import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SessionHeaderProps } from "../../pages/sessionTrackList/sessionHeader";
import { SessionMetricData } from "../../pages/sessionTrackList/sessionDetails";

interface SessionStateType {
  selectedSession: (SessionHeaderProps & SessionMetricData) | null;
}

const sessionState: SessionStateType = {
  selectedSession: null,
};

const sessionSlice = createSlice({
  name: "session",
  initialState: sessionState,
  reducers: {
    setSelectedSession: (
      state,
      action: PayloadAction<SessionHeaderProps & SessionMetricData>
    ) => {
      state.selectedSession = action.payload;
    },

    clearSelectedSession: (state) => {
      state.selectedSession = null;
    },
  },
});

export const { setSelectedSession, clearSelectedSession } =
  sessionSlice.actions;
export default sessionSlice.reducer;
